<template>
  <div>
    <transition name="slide-fade" appear>
      <b-row>
        <EncabezadoEstudiante/>
        <b-col cols="lg-12">
          <h2>Mis Tareas</h2>
            <b-card>
              <b-form-group class="mt-2">
                <b-form-select id="aulas" v-model="idAsignaturaDocente" :options="selectAsignaturasEstudiante" @change="cargaActividades()">
                    <template slot="first"><option :value="null" disabled>-- Seleccione una Asignatura --</option></template>
                </b-form-select>
              </b-form-group>
              <div v-if="idAsignaturaDocente">
                <div v-if="hayActividades">
                  <b-table small hover responsive :items="listaActividades" :fields="titulosActividades">
                    <template v-slot:cell(titulo)="row">
                        <div v-if="validarFechaVigencia(row.item.fecha_vigencia)">
                            <b-badge variant="success" pill v-b-tooltip.hover :title="'Vence el ' + fechaVigencia(row.item.fecha_vigencia)" class="text-success">-</b-badge>
                            <a :href="`#`" class=""><span @click="consultarActividad(row.item)"> {{ row.item.titulo.toUpperCase() }}</span></a>
                        </div>
                        <div v-else>
                            <b-badge variant="danger" pill v-b-tooltip.hover title="Actividad Cerrada" class="text-danger">-</b-badge>
                            <a :href="`#`" class="text-muted"><span @click="consultarActividad(row.item)"> {{ row.item.titulo.toUpperCase() }}</span></a>
                        </div>
                    </template>
                    <template v-slot:cell(tarea)="row">
                        <TareaActividad :datosActividad="{ idActividad: row.item.id, tituloActividad: row.item.titulo, estadoVigencia: validarFechaVigencia(row.item.fecha_vigencia), idAsignaturaDocente: idAsignaturaDocente }"/>
                    </template>
                  </b-table>
                </div>
                <div v-else>
                  <p class="text-danger">No existen actividades programadas para la asignatura.</p>
                </div>
              </div>
              <div v-else class="ml-5 text-muted">
                <p>Al seleccionar una asignatura el estudiante puede realizar las siguientes acciones:
                  <ul>
                    <li>Ver la guía o actividad que el docente envío</li>
                    <li>Iniciar una tarea</li>
                    <li>Editar y modificar una tarea</li>
                    <li>Enviar una tarea</li>
                    <li>Adjuntar un archivo a una tarea</li>
                    <li>Consultar el estado y evaluación de una tarea</li>
                    <li>Ver los mensajes de la interacción con el docente al realizar una tarea</li>
                  </ul>
                </p>
              </div>
            </b-card>
        </b-col>
      </b-row>
    </transition>

    <b-modal scrollable size="xl" title="Actividad - Guia de Trabajo" header-bg-variant="warning" header-text-variant="light" v-model="verModalConsultarActividad">
      <b-card-text>
        <form>
          <div class="container">
            <b-row>
              <b-col lg="8">
                <b-form-group label="Titulo de la Actividad:" label-for="titulo">
                  <b-form-input id="titulo" v-model="actividadSeleccionada.titulo" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group label="Fecha de Entrega:" label-for="vigencia">
                  <b-form-input id="vigencia" v-model="actividadSeleccionada.fvigencia" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" disabled></ckeditor>
              </b-col>
            </b-row>
            <b-card class="mt-3">
              <b-card-text>
                <div class="large-12" v-if="actividadSeleccionada.linkAdjunto === null">
                  <label class="text-danger">No se adjuntaron archivos</label><br>
                </div>
                <div v-else>
                  <p>Archivo adjunto:<br>{{ this.actividadSeleccionada.adjunto }}
                    <a class="btn btn-outline-primary ml-5 px-5" :href="this.actividadSeleccionada.linkAdjunto" target="_blank">Descargar</a>
                  </p>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </form>
      </b-card-text>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="px-5" variant="danger" @click="cancel()"> Cerrar </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import EncabezadoEstudiante from '@/containers/EncabezadoEstudiante'
  import TareaActividad from '@/components/TareaActividad'

  export default {
    name: 'MisTareas',
    components: {
      EncabezadoEstudiante,
      TareaActividad
    },
    data () {
      return {
        asignaturasEstudiante: [],
        selectAsignaturasEstudiante: [],
        idAsignaturaDocente: null,
        hayActividades: null,
        titulosActividades: [
          { key: 'id', label: '#' }, 
          { key: 'titulo', label: 'NOMBRE DE LA ACTIVIDAD (Consulte la guía haciendo clic sobre el nombre de la actividad)', width: '50px' },
          { key: 'tarea', label: 'TAREA' }
        ],
        verModalConsultarActividad: false,
        editor: ClassicEditor,
        editorData: '',
        editorConfig: {},
        actividadSeleccionada: {},
        fechaActualServidor: null
      }
    },
    methods: {
      //OK
      consultarActividad(actividad) {
        this.actividadSeleccionada.fvigencia = this.fechaVigencia(actividad.fecha_vigencia)
        this.actividadSeleccionada.titulo = actividad.titulo
        this.editorData = actividad.contenido
        if (actividad.adjunto == null || actividad.adjunto == '') {
          this.actividadSeleccionada.adjunto = null
          this.actividadSeleccionada.linkAdjunto = null
        } else {
          this.actividadSeleccionada.adjunto = actividad.adjunto
          this.actividadSeleccionada.linkAdjunto = 'https://sised.com.co/APISised/colegios/' + this.$store.state.bdColegio + '/descargas/aulas/' + actividad.adjunto
        }
        this.verModalConsultarActividad = true
      },
      //OK
      async cargaActividades() {
        this.listaActividades = {}
        this.hayActividades = false
        await axios
        .get(CONFIG.ROOT_PATH + "actividades/asignaturagrado/", { params: { bd: this.$store.state.bdColegio, idasignaturagrado: this.idAsignaturaDocente, lectivo: this.$store.state.lectivoColegio, idcurso: this.$store.state.idCursoUsuario }})
        .then(response => {
          if (response.data.error){
              this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
            if (response.data.datos != 0){
                this.listaActividades = response.data.datos
                this.hayActividades = true
            }
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
        })
      },
      //OK
      fechaVigencia(fecha) {
        let fechaVigenciaActividad = new Date(fecha)
        fechaVigenciaActividad = fechaVigenciaActividad.toLocaleDateString() + ' | ' + fechaVigenciaActividad.toLocaleTimeString()
        return fechaVigenciaActividad
      },
      //OK
      async cargarAsignaturasEstudiante() {
        await axios
        .get(CONFIG.ROOT_PATH + "asignaturas/estudiante", { params: { bd: this.$store.state.bdColegio, idgradosede: this.$store.state.idGradoSedeUsuario, lectivo: this.$store.state.lectivoColegio }})
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
            this.asignaturasEstudiante = response.data.datos
            this.asignaturasEstudiante.forEach((item) => {
              this.selectAsignaturasEstudiante.push({value: item.id_asignatura_grado, text: item.descripcion})
            })
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
        })
      },
      //OK
      validarFechaVigencia(fecha) {
        //let fechaAhora = new Date()
        if (this.fechaActualServidor == null) {
          return false
        } else {
          let fechaAhora = new Date(this.fechaActualServidor)
          let fechaVigencia = new Date(fecha) 
          if (fechaVigencia.getTime() >= fechaAhora.getTime())
              return true
          else 
              return false
        }
      },
      //OK
      validarSesion() {
        if (this.$store.state.idUsuario == '' || this.$store.state.idUsuario == null) {
          this.$router.push("/pages/sesionfinalizada")
        } else {
          this.cargarAsignaturasEstudiante()
        }
      },
      // PRUEBA
      async fechaServidor() {
        this.fechaActualServidor = null
        await axios
        .get(CONFIG.ROOT_PATH + "fechaservidor")
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente("danger","Mensaje",response.data.error)
          } else{
            this.fechaActualServidor = response.data.datos
            console.log("Fecha del Servidor: ",  new Date(this.fechaActualServidor))
            console.log("Fecha del Equipo: ", new Date())
          }
        })
      },
      //OK
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
      }
    },
    beforeMount() {
      this.validarSesion()
      this.fechaServidor()
    }
  }
</script>